import { openBlock as t, createElementBlock as a, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ e("g", { "clip-path": "url(#a)" }, [
  /* @__PURE__ */ e("path", {
    "fill-rule": "evenodd",
    d: "M3.638 1a.7.7 0 0 1 .7-.7h8.57a.7.7 0 0 1 .383.113l1.88 1.225a.7.7 0 0 1 0 1.173l-1.88 1.225a.7.7 0 0 1-.383.113H9.877v1.22h1.574a.7.7 0 0 1 .7.7v2.448a.7.7 0 0 1-.7.7H9.878v5.787a.7.7 0 0 1-.7.7H6.73a.7.7 0 0 1-.7-.7V9.218H2.88a.7.7 0 0 1-.382-.113L.618 7.879a.7.7 0 0 1 0-1.173l1.88-1.224a.7.7 0 0 1 .382-.114h3.15v-1.22H4.337a.7.7 0 0 1-.7-.699V1Zm3.791 4.368h1.048v-1.22H7.429v1.22Zm-.684 2.45a.661.661 0 0 0-.031 0H3.088l-.805-.525.805-.525h7.663v1.05H9.194a.66.66 0 0 0-.031 0H6.745Zm.684 1.4v5.087h1.05V9.216h-1.05ZM5.038 1.7v1.049H12.7l.805-.524L12.7 1.7H5.038Z",
    "clip-rule": "evenodd"
  })
], -1), h = /* @__PURE__ */ e("defs", null, [
  /* @__PURE__ */ e("clipPath", { id: "a" }, [
    /* @__PURE__ */ e("path", { d: "M0 0h16v16H0z" })
  ])
], -1), n = [
  l,
  h
];
function c(d, s) {
  return t(), a("svg", o, [...n]);
}
const v = { render: c };
export {
  v as default,
  c as render
};
